import { useEffect, useState } from "react";
import {
  CloseButton,
  StatusMessage,
} from "../../style/view.styles";
import LoadingSpinner from "./LoadingSpinner";
import { fetchEntityData, saveEntityData } from "../../utils/RequestHandler";
import { getLoggedInProfile } from "../../utils/AuthHandler";
import {
  FormContainer,
  StyledForm,
  StyledFormField,
  StyledLabel,
  StyledTextarea,
  Title,
} from "../../style/modal.form.style";
import { FaPen } from "react-icons/fa";
import FullButton from "../Buttons/FullButton";

const JoinProgramForm = ({
  selectedProgram,
  handleModalClose,
  setIsApplicationSubmitted,
}) => {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [applicantId, setApplicatId] = useState(null);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [formData, setFormData] = useState({
    cover_letter: "",
  });

  useEffect(() => {
    const setDefaultStatus = async () => {
      try {
        const response = await fetchEntityData("application_status");
        if (response.success) {
          setApplicationStatus(
            response.result.find((item) => item.status === "new").id
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    const setApplicant = async () => {
      try {
        const applicant = await getLoggedInProfile();
        if (applicant) setApplicatId(applicant.id);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    setDefaultStatus();
    setApplicant();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = async () => {
    try {
      setSubmitting(true);
      const requestData = {
        ...formData,
        applicant: applicantId,
        program: selectedProgram.id,
        status: applicationStatus,
      };
      const response = await saveEntityData("program_application", requestData);
      if (response.success) {
        setFormStatus({
          message: "Application sent successfully!",
          type: "success",
        });
        setIsApplicationSubmitted(true);
        handleModalClose();
      } else {
        setFormStatus({
          message:
            response.message ??
            "An error occurred while submitting your request. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setFormStatus({
        message:
          "An error occurred while submitting your application. Please try again.",
        type: "error",
      });
    } finally {
      setSubmitting(true);
    }
  };

  return (
    <FormContainer>
      <CloseButton onClick={handleModalClose}>X</CloseButton>
      <Title>Join {selectedProgram?.name} program</Title>
      <StyledForm>
        {loading && <LoadingSpinner />}
        {!loading && (
          <StyledFormField fullWidth>
            <StyledLabel>
              <FaPen style={{ marginRight: 5 }} /> Cover letter
            </StyledLabel>
            <StyledTextarea
              name="cover_letter"
              placeholder="Tell us why you would like to join the program."
              rows="4"
              value={formData.cover_letter}
              onChange={handleInputChange}
              required
            />
          </StyledFormField>
        )}
      </StyledForm>
      <FullButton
        action={handleFormSubmit}
        type="submit"
        disabled={submitting}
        title={submitting ? "Submitting..." : "Submit Application"}
      />
      {formStatus.message && (
        <StatusMessage type={formStatus.type}>
          {formStatus.message}
        </StatusMessage>
      )}
    </FormContainer>
  );
};

export default JoinProgramForm;
